<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-20 11:22:43
 * @LastEditors: 诺
 * @LastEditTime: 2023-02-09 15:12:18
-->

<template>
  <div
    class="boxMian"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.backgroundImg}')` }">
      <div class="kv"><img :src="configInfo.mainKvImg" /></div>
      <div class="model" :style="{ backgroundColor: `${configInfo.mainColour}80` }">
        <div
          class="modelTitle"
          :style="{
            backgroundColor: configInfo.mainColour,
            color: configInfo.buttonTextColour,
          }"
        >
          · 我的奖品 ·
        </div>

        <div class="modelBg">
          <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index" :style="{ borderColor: rgbToRgba(configInfo.mainColour, 0.2) }">
              <img v-if="item.prizeType == 4" class="img" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/conpus.png" />
              <img v-else-if="item.prizeType == 1" class="img" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/money.png" />
              <img v-else class="img" :src="item.prizeImg || 'http://assets.rurushishi.com/activies/fortune-cat/prize_icon.png'" />
              <div class="name">{{ item.prizeName }}</div>
              <div class="btn" v-if="item.status == 1">
                <div class="receive" @click="receive(item)" :style="{ backgroundColor: configInfo.mainColour }">兑换 {{ item.time }}</div>
              </div>

              <div class="btn" v-else-if="item.status == 2">
                <template v-if="item.prizeType == 3">
                  <div v-if="!item.cardNo" class="receive" :style="{ backgroundColor: configInfo.mainColour }" @click="showQrCode(item)">已发放</div>
                  <div v-else class="receive" :style="{ backgroundColor: configInfo.mainColour }" @click="showQrCode(item)">兑换码</div>
                </template>
                <template v-else-if="item.prizeOffStatus == 1">
                  <div class="prizeOffBtn">已兑换</div>
                </template>
                <template v-else>
                  <div class="btn" v-if="item.prizeSendStatus == 3">
                    <div class="receive" :style="{ backgroundColor: configInfo.mainColour }">发送中</div>
                  </div>
                  <div class="btn" v-else-if="item.prizeSendStatus == 1">
                    <div class="receive" :style="{ backgroundColor: configInfo.mainColour }">发送失败</div>
                  </div>
                  <template v-else>
                    <div :class="item.prizeOffStatus == 0 ? 'code' : 'prizeOff code'">
                      {{ item.prizeOffCode }}
                    </div>
                    <div v-if="item.prizeOffStatus == 0 && (item.prizeType == 2 || item.prizeType == 4|| item.prizeType == 5)" class="qrCode" @click="showQrCode(item)" :style="{ backgroundColor: configInfo.mainColour }">
                      兑奖码
                    </div>
                  </template>
                </template>
              </div>
            </div>

            <div class="common-nodata" v-if="list.length === 0">
              <div class="zero">
                <div class="zero_top">
                  <img src="http://assets.rurushishi.com/activies/online/dtt-purchase/gift_zero.png" alt />
                </div>
                <div class="zero_bottom">
                  <p>空空如也，您还没有任何奖品</p>
                  <p>快去参加活动领奖品吧～</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BaseBottom :configInfo="configInfo" />
      <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>
    </div>
    <div class="qrModel" v-if="qrCode">
      <div class="qrCodeModel">
        <img class="qrImg" :src="src" />
        <img class="close" @click="qrCode = false" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { rgbToRgba } from "./components/util";
// import Vue from "vue/dist/vue.js";
// import Grid from "./components/grid";
// import Pointer from "./components/pointer";
// import ButtonList from "./components/buttonList";
// import { getUserInfo2 } from "@/http/rushi-wx";

// const statusTipMap = {
//   0: "该活动无效",
//   1: "该活动待发布",
//   2: "该活动未上线",
//   4: "该活动已下线",
//   5: "该活动已下线",
// };

export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo: {}, //配置信息
      list: [],
      src: "",
      qrCode: false,
    };
  },

  mounted() {
    this.configInfo = this.$configInfo;
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
    this.initMyPrize();
  },
  methods: {
    rgbToRgba,
    calcTime() {
      setTimeout(() => {
        let time = new Date().getTime();
        for (let item of this.list) {
          if (item.status == 1) {
            item.time = item.deadline && parseInt((item.deadline - time) / 1000);
          }
        }
        this.list = this.list.filter((x) => x.time >= 0);
        if (this.list.some((x) => x.status == 1 && x.time >= 0)) {
          this.calcTime();
        }
      }, 1000);
    },
    // 页面配置
    async initMyPrize() {
      let param = this.$apizt.action.getMyPrize;
      const { data, result } = await this.$httpzt.requestRestFul(param, {});
      if (result) {
        console.log(data);
        let time = new Date().getTime();
        data.forEach((x) => {
          if (x.status == 1) {
            x.time = x.deadline && parseInt((x.deadline - time) / 1000);
          } else {
            x.time = 0;
          }
        });
        this.calcTime();
        this.list = data;
      }
    },
    showQrCode(item) {
      // this.src = item.prizeOffQrCode;
      // this.qrCode = true;
      if (item.prizeType == 1) {
        this.$showToast("已通过微信支付发放，请注意查收。");
        return;
      }
      this.$modal.qrCode.alert({
        ...item,
        // url:'https://assets-cos-test.yqaitech.com/null/common/image/aee1ef7862e1467c8079df2ea7d0563e.png',
        // code:'xxxxxxxx',
        // time:'12月12号',
        // address:'xxxxx'
      });
    },
    receive(item) {
      if (item.status == 1) {
        this.$modal.form
          .alert({
            type: "key",
            code: item.code,
            prizeType: item.prizeType,
            prizeName: item.prizeName,
            receiveKey: item.receiveKey,
            deadline: item.deadline,
            category: item.category,
            winType: item.winType,
          })
          .then(() => {
            this.initMyPrize();
          });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 80px;
    .kv {
      width: 343px;
      margin: 40px auto 0;
      img {
        max-width: 100%;
        height: auto;
      }
    }

    .model {
      width: 351px;
      margin: 16px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 12px;
      box-sizing: border-box;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      padding:10px;
      border: 1px solid rgba(255, 255, 255, 0.1);

      .modelTitle {
        position: absolute;
        margin-top: -10px;
        color: white;
        padding: 0 20px;
        line-height: 40px;
        height: 40px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        z-index: 1;
        font-size: 20px;
        font-weight:bold;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 12px 12px;
      }

      .modelBg {
        width: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 7px;
        padding: 40px 20px 10px;

        .list {

          .item {
            width: 100%;
            display: flex;
            height: 80px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);
            word-break: break-all;

            .img {
              width: 48px;
              height: 48px;
              object-fit: contain;
              border-radius: 4px;
              overflow:hidden;
            }

            .name {
              flex: 1;
              padding: 0 16px;
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
              color: #000000;
            }

            .btn {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 90px;
            }

            .prizeOffBtn {
              height: 24px;
              border-radius: 12px;
              text-align: center;
              padding: 0 10px;
              line-height: 24px;
              color: #A3AFBF;
              background: rgba(0, 0, 0, 0.05);
              font-size:12px;
            }

            .receive, .qrCode {
              height: 24px;
              border-radius: 12px;
              text-align: center;
              padding: 0 10px;
              line-height: 24px;
              color: white;
              font-size:12px;
            }

            .qrCode {
              margin-top: 4px;
            }

            .code {
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
              display: none;
            }

            .prizeOff {
              text-decoration: line-through;
              color: #999;
            }
          }
        }

        .item:last-child {
          border-bottom: none;
        }

        .common-nodata {
          font-size: 14px;
          // font-weight bold;
          text-align: center;
          font-family: PingFang SC;
          margin-top: 20px;
          overflow: hidden;

          .zero {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-top: 32px;

            .zero_top {
              width: 356px;
              height: 98px;

              img {
                width: 100%;
                height: 100px;
              }
            }

            .zero_bottom {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 400;
              color: rgba(154, 154, 154, 1);
              line-height: 24px;
            }
          }
        }
      }
    }
  }

  .qrModel {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .qrCodeModel {
      position: relative;
      widh: 240px;

      .qrImg {
        width: 240px;
      }

      .close {
        position: absolute;
        top: -38px;
        right: -15px;
        width: 30px;
        height: 30px;
        z-index: 1002;
      }
    }
  }
}
</style>
